import type { TeamContent } from "../types";
import { renderSectionHeader } from "./section-header";

/** 团队：职能域网格（参考 Anthropic 的 Research/Policy/Product/Operations） */
export function renderTeam(team: TeamContent): string {
  const domains = team.domains
    .map(
      (d, i) => `
      <div class="domain" data-reveal style="--i:${i}">
        <h3>${d.name}</h3>
        <p>${d.description}</p>
      </div>`,
    )
    .join("");

  return `
    <section class="section" id="${team.id}">
      ${renderSectionHeader(team.header)}
      <div class="domains">${domains}</div>
    </section>`;
}
